export default function TrashIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 3V1C7 0.447715 7.44772 0 8 0H12C12.5523 0 13 0.447715 13 1V3H17C17.5523 3 18 3.44772 18 4C18 4.55228 17.5523 5 17 5H16V16C16 17.6569 14.6569 19 13 19H7C5.34315 19 4 17.6569 4 16V5H3C2.44772 5 2 4.55228 2 4C2 3.44772 2.44772 3 3 3H7ZM9 2V3H11V2H9ZM6 5V16C6 16.5523 6.44772 17 7 17H13C13.5523 17 14 16.5523 14 16V5H6ZM8 8C8.55228 8 9 8.44772 9 9V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V9C7 8.44772 7.44772 8 8 8ZM12 8C12.5523 8 13 8.44772 13 9V14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V9C11 8.44772 11.4477 8 12 8Z" />
    </svg>
  );
}
